/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ActionAnimate64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ActionAnimate64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M28.5075 29.5V18L19.0247 33.635C18.7944 34.0146 19.0677 34.5 19.5117 34.5H28.5075V46L37.9764 30.3647C38.2063 29.9851 37.933 29.5 37.4891 29.5H28.5075Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            opacity="0.6"
            d="M30 29V22.001L32.5 18V29M41.699 29.5C42.0459 29.5001 42.0699 29.8458 41.8881 30.1494L32.5 46V42L40 29.5H41.699Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
          <path
            opacity="0.4"
            d="M34 29V22.001L36.5 18V29M45.699 29.5C46.0459 29.5001 46.0699 29.8458 45.8881 30.1494L36.5 46V42L43.7528 29.5H45.699Z"
            stroke="currentColor"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ActionAnimate64Icon.tags = [
  'animation',
  'play',
  'movement',
  'dynamic',
  'motion',
];

ActionAnimate64Icon.category = '64x64 (Add panel)';

ActionAnimate64Icon.iconSize = 64;
